<script>
	import { twMerge } from 'tailwind-merge';
	let className = '';
	export { className as class };
	import Button from '../ui/Button.svelte';
	import Justin from '$lib/assets/sections/The-Wrap-Institute-Trainer-Justin-Pate.png';
	import Dimas from '$lib/assets/sections/The-Wrap-Institute-Trainer-Dimas-Brasil.png';
	import Rainer from '$lib/assets/sections/The-Wrap-Institute-Trainer-Rainer-Lorz.png';
	import MembersOnly from '$lib/assets/sections/members-only.svg';
</script>

<section
	class={twMerge(
		'flex items-center justify-center bg-black px-2 py-16 text-white sm:py-24 md:px-8 md:py-32 lg:py-40 xl:py-48 2xl:py-56',
		className
	)}
>
	<div class="mx-auto flex w-full max-w-screen-xl flex-col items-start px-4 sm:px-0">
		<div class="mb-8 flex w-full flex-row items-center justify-between">
			<div class="mb-4 sm:mb-0">
				<h3 class="mb-4 text-lg italic sm:text-xl md:text-2xl lg:text-3xl">
					TWI Town Hall: Connect, Grow And Be Inspired Together
				</h3>
				<h2 class="text-2xl font-bold sm:text-3xl md:text-4xl lg:text-5xl">Meet Your Trainers</h2>
			</div>
			<img
				src={MembersOnly}
				alt="Members Only"
				class="mb-8 w-32 self-end object-contain object-center sm:mb-0 sm:w-48"
			/>
		</div>

		<div class="mb-24 flex flex-col px-4 sm:flex-row sm:justify-center sm:gap-8">
			<div class="relative mb-4 h-auto w-full sm:mb-0 sm:w-1/3 lg:w-1/3">
				<img src={Justin} alt="Justin" class="h-full w-full object-cover object-center" />
				<div
					class="absolute bottom-1/4 left-1/2 -translate-x-1/2 transform text-5xl font-black text-primary-400 sm:text-3xl md:text-4xl lg:text-5xl"
				>
					Justin
				</div>
			</div>
			<div class="relative mb-4 h-auto w-full sm:mb-0 sm:w-1/3 lg:w-1/4">
				<img src={Rainer} alt="Rainer" class="h-full w-full object-cover object-center" />
				<div
					class="absolute bottom-1/4 left-1/2 -translate-x-1/2 transform text-5xl font-black text-primary-400 sm:text-3xl md:text-4xl lg:text-5xl"
				>
					Rainer
				</div>
			</div>
			<div class="relative mb-4 h-auto w-full sm:mb-0 sm:w-1/3 lg:w-1/4">
				<img src={Dimas} alt="Dimas" class="h-full w-full object-cover object-center" />
				<div
					class="absolute bottom-1/4 left-1/2 -translate-x-1/2 transform text-5xl font-black text-primary-400 sm:text-3xl md:text-4xl lg:text-5xl"
				>
					Dimas
				</div>
			</div>
		</div>

		<div class="flex w-full justify-center py-8">
			<a href="/live">
				<Button size="lg">Livestreams</Button>
			</a>
		</div>
	</div>
</section>
